import React, {useState} from 'react';
import Translate, {t} from "../../../../../../../components/Translate";
import Input from "../../../../../../../components-new/Input";
import {addWebhook} from "../../../../../../../services/company/api";
import config from "../../../../../../../config";
import {confirmActionRequested} from "../../../../../../../services/confirmAction/action";
import {connect} from "react-redux";
import WebhooksModal from "../../../../../../../components/WebhooksModal";
import BlueButton from "../../../../../../../components-new/buttons/BlueButton";
import {silverInfoStyles} from "../../../../../../../utils/General";

const Webhooks = ({
                      client,
                      webhooks,
                      setWebhooks,
                      user,
                      confirmAction,
                      updateWebhooksState,
                      setUpdateWebhooksState
                  }) => {

    const [api, setApi] = useState('');
    const [token, setToken] = useState('');
    const [headerName, setHeaderName] = useState('');
    const [type, setType] = useState(config.webhookTypes.connectToOperator);


    const onApiChange = (event) => {
        setApi(event.target.value)
    }

    const onTokenChange = (event) => {
        setToken(event.target.value)
    }

    const onHeaderNameChange = (event) => {
        setHeaderName(event.target.value)
    }

    const saveWebhook = () => {
        addWebhook(client.id, api, token, type, headerName)
            .then(res => {
                setUpdateWebhooksState(!updateWebhooksState);
                setApi('');
                setToken('');
                setHeaderName('');
                setType(config.webhookTypes.connectToOperator);
            })
            .catch(err => {
                console.error("Error adding webhook", err);
            });
    };

    const openModal = () => {
        confirmAction({
                content: <WebhooksModal updateWebhooksState={updateWebhooksState}
                                        setUpdateWebhooksState={setUpdateWebhooksState}
                                        webhooks={webhooks} setWebhooks={setWebhooks}/>
            }
        );
    };

    return (
        <div style={{padding: '5px', margin: '10px'}}>
            <h2 style={{fontSize: '16px', color: 'rgb(164, 173, 193)', marginBottom: '20px'}}>
                <Translate text={'webhooks'}/>
            </h2>

            <span onClick={openModal} style={{cursor: 'pointer'}}><Translate text={'showWebhooks'}/> ({webhooks.length})</span>

            <div style={{display: 'flex', gap: '5px', flexDirection: 'column', marginTop: '10px'}}>

                <div style={{
                    ...silverInfoStyles.info,
                    marginLeft: '0px',
                    marginBottom: '20px',
                    textAlign: 'center'
                }}>
                    <Translate text="webhooksInfo"/>
                </div>

                <br/>

                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Input placeholder={'API'} name={'api'} value={api} onChange={(e) => onApiChange(e)}/>
                    <Input placeholder={'Token'} name={'token'} value={token} onChange={(e) => onTokenChange(e)}/>
                    <Input placeholder={'Header name'} name={'headerName'} value={headerName}
                           onChange={(e) => onHeaderNameChange(e)}/>
                    <select style={{
                        display: 'block',
                        backgroundColor: 'white',
                        border: '1px solid rgb(221, 221, 221)',
                        fontSize: '16px',
                        padding: '10px',
                        borderRadius: '10px',
                        marginBottom: '10px',
                    }}
                            value={type}
                            onChange={
                                (e) => {
                                    setType(e.target.value)
                                }
                            }>
                        <option value={config.webhookTypes.connectToOperator}>{t({
                            text: "connectToOperator",
                            user
                        })}</option>
                    </select>
                    <BlueButton
                        height={'43px'}
                        styles={{fontSize:'11px'}}
                        width={'105px'}
                        onClick={saveWebhook}
                        children={<Translate text={'add'}/>}
                    />
                </div>

            </div>
        </div>
    );
};

const mapDispatchToProps = (dispatch) => ({
    confirmAction: (obj) => (dispatch(confirmActionRequested(obj.func, obj.args, obj.onCancel, obj.onCancelArgs, obj.content))),
});

export default connect(null, mapDispatchToProps)(Webhooks);


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/functions/Webhooks.jsx